import {Show} from 'platform/foundation';
import {useTheme} from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

/** Band columns narrower than this (SVG units) hide their per-band share label. */
const BAND_SHARE_LABEL_MIN_WIDTH = 40;

export interface BandColumn {
  x: number;
  labelX: number;
  fill: string;
  sharePercent: number;
}

interface BandColumnsProps extends TestIdProps {
  columns: BandColumn[];
  /** Pixel width of one band column. */
  slotWidth: number;
  /** Top edge of the tinted column area. */
  zoneTopY: number;
  baselineY: number;
}

/**
 * Band-axis backgrounds: one gradient-tinted column per portal price band, with its
 * share of cars on top while the columns are wide enough for the label. The labels
 * sit on the same row the linear percent labels use — above the marker pill, which
 * spans the zone below.
 */
export function BandColumns(props: BandColumnsProps) {
  const theme = useTheme();
  const isShareLabelVisible = props.slotWidth >= BAND_SHARE_LABEL_MIN_WIDTH;

  return (
    <g data-testid={suffixTestId('bandColumns', props)}>
      {props.columns.map((column) => (
        <g key={column.x}>
          <rect
            x={column.x}
            y={props.zoneTopY}
            width={props.slotWidth}
            height={props.baselineY - props.zoneTopY}
            fill={column.fill}
          />
          <Show when={isShareLabelVisible}>
            <text
              x={column.labelX}
              y={props.zoneTopY - 2}
              fontSize={theme.fontSizes.text.xxSmall}
              fontWeight={theme.fontWeights.text.default}
              fill={theme.colors.text.secondary}
              textAnchor="middle"
            >
              {`${column.sharePercent} %`}
            </text>
          </Show>
        </g>
      ))}
    </g>
  );
}
